import { ThunkAction } from "redux-thunk";
import { IErrorReceiveOrganizationsAction, IReceiveOrganizationsAction, IRequestOrganizationsAction, OrganizationsAction } from "./models";
import { IOrganization, IOrganizationItems } from "../models";
import { createUIError, IUIError } from "@gtmhub/error-handling";
import { IOrganizationsStoreState } from "./organizations-reducer";
import { WorkdayUserProvisioningService } from "../workday-user-provisioning-service";
import { IPromise, IQService } from "angular";

const requestOrganizations = (): IRequestOrganizationsAction => ({ type: "REQUEST_ORGANIZATIONS" });
const receiveOrganizations = (items: IOrganization[]): IReceiveOrganizationsAction => ({ type: "RECEIVE_ORGANIZATIONS", items });
const requestOrganizationsError = (error: IUIError): IErrorReceiveOrganizationsAction => ({ type: "ERROR_RECEIVE_ORGANIZATIONS", error });

const shouldFetchOrganizations = (state: IOrganizationsStoreState) => !state.organizations.isFetching && !state.organizations.isFetched;
const maxOrganizationsNoInResponse = 1000;
export class OrganizationsActions {
  public static $inject = ["WorkdayUserProvisioningService", "$q"];

  constructor(private workdayUserProvisioningService: WorkdayUserProvisioningService, private $q: IQService) {}

  public fetchOrganizationsIfMissing(): ThunkAction<void, IOrganizationsStoreState, null, OrganizationsAction> {
    return (dispatch, getState) => {
      if (shouldFetchOrganizations(getState())) {
        dispatch(requestOrganizations());

        this.workdayUserProvisioningService.getOrganizations({ mark_selected: true, skip: 0, take: 1000 }).then(
          (response) => {
            this.dispatchAllOrganizations(response, dispatch);
          },
          (rejection) => dispatch(requestOrganizationsError(createUIError(rejection)))
        );
      }
    };
  }

  public fetchOrganizations(): ThunkAction<void, IOrganizationsStoreState, null, OrganizationsAction> {
    return (dispatch) => {
      dispatch(requestOrganizations());
      this.workdayUserProvisioningService.getOrganizations({ mark_selected: true, skip: 0, take: 1000 }).then(
        (response) => {
          this.dispatchAllOrganizations(response, dispatch);
        },
        (rejection) => dispatch(requestOrganizationsError(createUIError(rejection)))
      );
    };
  }

  private createPromises(noOfPromise: number): IPromise<IOrganizationItems>[] {
    const promises = [];
    for (let index = 1; index <= noOfPromise; index++) {
      promises.push(this.workdayUserProvisioningService.getOrganizations({ mark_selected: true, skip: index * maxOrganizationsNoInResponse, take: 1000 }));
    }
    return promises;
  }

  private dispatchAllOrganizations(response: IOrganizationItems, dispatch) {
    const organizations = response.items;
    const noOfCallsReq = Math.floor(response.totalCount / maxOrganizationsNoInResponse);
    if (noOfCallsReq > 0) {
      this.$q.all(this.createPromises(noOfCallsReq)).then((responses) => {
        responses.forEach((organizationsRes) => {
          organizations.push(...organizationsRes.items);
        });
        dispatch(receiveOrganizations(organizations));
      });
    } else {
      dispatch(receiveOrganizations(organizations));
    }
  }
}
